import type { ReactNode } from "react";

export function Layout({
  children,
  compact = false,
}: {
  children: ReactNode;
  compact?: boolean;
}) {
  return (
    <div className="app-shell">
      <header className="topbar">
        <a href="/" className="brand" aria-label="Medinotify หน้าหลัก">
          <span className="brand-mark">ค</span>
          <span>
            <strong>Medinotify</strong>
            <small>LINE QUEUE</small>
          </span>
        </a>
        <span className="connection-dot">
          <i />
          เชื่อมต่อ LINE
        </span>
      </header>
      <main className={compact ? "content content--compact" : "content"}>{children}</main>
      <footer>
        <span>ระบบคิวแบบเรียลไทม์</span>
        <span>แจ้งเตือนผ่าน LINE เมื่อถึงคิว</span>
      </footer>
    </div>
  );
}
